import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SplitService } from 'src/app/services/split/split.service';

import {
  ReportService,
  ReportGroup,
  Report,
} from '../../../services/report/report.service';
import { UserService } from '../../../services/user/user.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics/google-analytics.service';
import { AuditLogService } from '../../../services/audit/audit-log.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  standalone: false,
})
export class NavMenuComponent implements OnInit {
  public readonlyReportGroups: ReportGroup[];
  public externalReportGroups: ReportGroup[];
  public adminReportGroups: ReportGroup[];
  public displayedReportGroups: ReportGroup[];
  public showActiveClass: boolean = false;
  internalNonAdminUser: boolean = false;
  adminUser: boolean = false;
  externalUser: boolean = false;
  internalUser: boolean = false;
  isAuthenticated: boolean = false;
  obtainingPermission: boolean = false;

  constructor(
    private reportService: ReportService,
    private user: UserService,
    public gaService: GoogleAnalyticsService,
    public auditService: AuditLogService,
    public router: Router,
    public splitService: SplitService,
  ) {
    this.user.isInternal.subscribe(v => {
      this.internalUser = v;
    });
    this.user.isAdmin.subscribe(v => {
      this.adminUser = v;
      if (v) this.displayedReportGroups = this.adminReportGroups;
    });
    user.isAuthenticated.subscribe(a => {
      this.isAuthenticated = a;
    });
    this.user.isInternalNonAdmin.subscribe(v => {
      this.internalNonAdminUser = v;
      if (v) this.displayedReportGroups = this.readonlyReportGroups;
    });
    this.user.isExternal.subscribe(v => {
      this.externalUser = v;
      if (v) this.displayedReportGroups = this.externalReportGroups;
    });
    this.user.obtainingPermissions.subscribe(v => {
      this.obtainingPermission = v;
    });
    this.user.token.pipe(filter(token => token != '')).subscribe(() => {
      this.setupReportMenu();
    });
  }

  ngOnInit() {
    this.updateActiveClassForReports();
  }

  setupReportMenu() {
    this.readonlyReportGroups = [];
    this.externalReportGroups = [];
    this.adminReportGroups = [];
    this.reportService.getReports().then(response => {
      response.groups.forEach(group => {
        let gp = new ReportGroup();
        gp.groupName = group.groupName;
        gp.reports = [];
        if (group.groupName === 'Admin Reports')
          this.adminReportGroups.push(gp);
        else if (group.groupName === 'ReadOnly Reports')
          this.readonlyReportGroups.push(gp);
        else if (group.groupName === 'External Reports')
          this.externalReportGroups.push(gp);

        group.reports.forEach(report => {
          let rp = new Report();
          if (report.name.endsWith('Crosses,Category and Confidence')) {
            rp.type = 'Custom';
          } else {
            rp.type = 'Standard';
          }
          rp.name = report.name;
          rp.id = report.id;
          rp.key = report.key;
          rp.route = '/reports/' + report.key.toString();
          gp.reports.push(rp);
        });
        if (this.adminUser) {
          this.displayedReportGroups = this.adminReportGroups;
        } else if (this.internalNonAdminUser) {
          this.displayedReportGroups = this.readonlyReportGroups;
        } else if (this.externalUser) {
          this.displayedReportGroups = this.externalReportGroups;
        }
      });
    });
  }

  updateActiveClassForReports() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((e: Event | any) => {
        if (
          e.url.match(/\/reports/i) !== null ||
          e.url.match(/\/cccReport/) !== null
        ) {
          this.showActiveClass = true;
        } else {
          this.showActiveClass = false;
        }
      });
  }

  clickEvent(tabName: string) {
    this.updateActiveClassForReports();

    this.gaService.tabClickEvent(tabName);
    this.auditService.tabClickEvent(tabName);
  }

  navigateTo(id: string, tabName: string, rtype: string) {
    this.updateActiveClassForReports();

    this.gaService.tabClickEvent(tabName);
    this.auditService.tabClickEvent(tabName);
    const uri = '/reports/' + id + '?reportType=' + rtype;
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigateByUrl(uri));
  }

  exportDisputedReport() {
    this.reportService.downloadDisputedCrossesReport();
  }
}
